const getters = {
    userdata: state => state.userdata,
    loading:state => state.loading,
    tag:state => state.tag,
    tagstatus:state => state.tagstatus,
    toggleflag:state => state.toggleflag,
    statechange:state => state.statechange,
  }
export default getters